/**
 * This file is generated on build. To make changes, see /templates/constants.ts
 */
const PACKAGE_NAME = '@twilio/voice-sdk';
const RELEASE_VERSION = '2.18.3';
const SOUNDS_BASE_URL = 'https://sdk.twilio.com/js/client/sounds/releases/1.0.0';
const COWBELL_AUDIO_URL = `${SOUNDS_BASE_URL}/cowbell.mp3?cache=${RELEASE_VERSION}`;
const ECHO_TEST_DURATION = 20000;

export { COWBELL_AUDIO_URL, ECHO_TEST_DURATION, PACKAGE_NAME, RELEASE_VERSION, SOUNDS_BASE_URL };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlcyI6WyIuLi8uLi9saWIvdHdpbGlvL2NvbnN0YW50cy50cyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7QUFFRztBQUNILE1BQU0sWUFBWSxHQUFHO0FBQ3JCLE1BQU0sZUFBZSxHQUFHO0FBQ3hCLE1BQU0sZUFBZSxHQUFHO0FBQ3hCLE1BQU0saUJBQWlCLEdBQUcsQ0FBQSxFQUFHLGVBQWUsQ0FBQSxtQkFBQSxFQUFzQixlQUFlO0FBQ2pGLE1BQU0sa0JBQWtCLEdBQUc7Ozs7In0=
